import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useIsSuperAdmin } from "@/lib/auth";
import { useEffect, useState } from "react";

export type SidebarConfig = {
  hidden: string[]; // list of `to` paths hidden from regular admins
  loading: boolean;
  error: string | null;
  save: (hidden: string[]) => Promise<void>;
};

export function useAdminSidebarConfig(): SidebarConfig {
  const { getAuthHeaders, isLoaded } = useAdminAuth();
  const isSuperAdmin = useIsSuperAdmin();
  const [hidden, setHidden] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoaded) return;
    setLoading(true);
    getAuthHeaders()
      .then((headers) => fetch("/api/admin/sidebar-config", { headers }))
      .then((r) => r.json())
      .then((d: { hidden?: string[] }) => setHidden(d.hidden ?? []))
      .catch((e) => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setLoading(false));
  }, [getAuthHeaders, isLoaded]);

  const save = async (newHidden: string[]) => {
    if (!isSuperAdmin) throw new Error("Solo super admin puede guardar la config");
    const headers = await getAuthHeaders();
    const res = await fetch("/api/admin/sidebar-config", {
      method: "POST",
      headers,
      body: JSON.stringify({ hidden: newHidden }),
    });
    if (!res.ok) {
      const d = await res.json() as { error?: string };
      throw new Error(d.error ?? "Error al guardar");
    }
    setHidden(newHidden);
  };

  return { hidden, loading, error, save };
}
